module.exports = __webpack_public_path__ + "static/media/view billing.251029cd.svg";